{
  "data": {
    "remarks": "Here are some remarks for the VA Form 22-8794.",
    "hasReadOnlyCertifyingOfficial": false,
    "view:introduction": {},
    "view:additionalOfficialSummary": false,
    "primaryOfficialBenefitStatus": {
      "hasVaEducationBenefits": true,
      "view:benefitsDisclaimer": true
    },
    "primaryOfficialDetails": {
      "fullName": { "first": "Bob", "middle": "Test", "last": "Smith" },
      "title": "Certifying Official",
      "phoneNumber": {
        "callingCode": 1,
        "countryCode": "US",
        "contact": "(231) 231-2222"
      },
      "emailAddress": "bob.smith@test.com"
    },
    "institutionDetails": {
      "facilityCode": "10002000",
      "institutionName": "INSTITUTE OF TESTING",
      "institutionAddress": {
        "street": "123 STREET WAY",
        "street2": "",
        "street3": "",
        "city": "SAN FRANCISCO",
        "state": "CA",
        "postalCode": "13579",
        "country": "USA"
      },
      "hasVaFacilityCode": true
    },
    "designatingOfficial": {
      "fullName": { "first": "John", "middle": "William", "last": "Doe" },
      "title": "President",
      "phoneNumber": {
        "callingCode": 1,
        "countryCode": "US",
        "contact": "(231) 231-2222"
      },
      "emailAddress": "john.doe@test.com"
    },
    "view:description": {},
    "primaryOfficialTraining": { "trainingExempt": true },
    "additionalCertifyingOfficials": [
      {
        "additionalOfficialBenefitStatus": { "hasVaEducationBenefits": false },
        "additionalOfficialTraining": {
          "trainingCompletionDate": "2025-07-02"
        },
        "additionalOfficialDetails": {
          "fullName": {
            "first": "Certifying",
            "middle": "Test",
            "last": "Official"
          },
          "title": "Vice Certifying Official",
          "phoneNumber": {
            "callingCode": 1,
            "countryCode": "US",
            "contact": "(231) 231-2222"
          },
          "emailAddress": "certifying.official@test.com"
        }
      },
      {
        "additionalOfficialBenefitStatus": {
          "hasVaEducationBenefits": false
        },
        "additionalOfficialTraining": {
          "trainingExempt": true
        },
        "additionalOfficialDetails": {
          "fullName": {
            "first": "Another",
            "middle": "Test",
            "last": "Official"
          },
          "title": "Principal Certifying Official",
          "phoneNumber": {
            "callingCode": 1,
            "countryCode": "US",
            "contact": "(231) 231-2222"
          },
          "emailAddress": "certifying.official2@test.com"
        }
      }
    ],
    "readOnlyCertifyingOfficials": [
      { "fullName": { "first": "Read", "middle": "Only", "last": "Official" } }
    ],
    "statementOfTruthSignature": "John William Doe",
    "statementOfTruthCertified": true
  }
}
